// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"u7-z"};